import * as React from 'react';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';

import { Grid } from 'semantic-ui-react';

import { Card } from '../..';
import { localeData } from '../../../locales/data';

import { FormattedMessageHelper } from '../../../shared/helpers/internationalization';

const Welcome = ({ intl }: InjectedIntlProps) => (
  <Grid.Column tablet={16} mobile={16} computer={10}>
    <Card
      hasHeader={false}
      hasFooter={true}
      footerLink="simulate"
      footerLinkModifiers={['intro-dashboard-step-8']}
      footerLinkLabel={intl.formatMessage({
        id: 'dashboardMain.dashboardUpperRow.startBuildingFirstAlpha',
        defaultMessage: localeData.en['dashboardMain.dashboardUpperRow.startBuildingFirstAlpha'],
      })}
      contentFull={true}
    >
      <div className="dashboard__info intro-dashboard-step-1">
        <h2 className="dasboard__info-title">
          <FormattedMessageHelper tagName="span" id="dashboardMain.title" defaultMessage={localeData.en['dashboardMain.title']} />
        </h2>
        <div>
          <FormattedMessageHelper tagName="span" id="dashboardMain.info" defaultMessage={localeData.en['dashboardMain.info']} />
        </div>
      </div>
    </Card>
  </Grid.Column>
);

export default injectIntl(Welcome);
